import React from 'react';

/**
 * Error boundary that catches React DOM reconciliation errors
 * (e.g. "insertBefore" failures caused by browser extensions modifying the DOM)
 * and recovers by re-rendering the component tree.
 */
class DOMErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Only catch DOM manipulation errors, let others propagate
    if (
      error?.message?.includes('insertBefore') ||
      error?.message?.includes('removeChild') ||
      error?.message?.includes('appendChild') ||
      error?.message?.includes('not a child of this node')
    ) {
      return { hasError: true };
    }
    // Re-throw non-DOM errors
    throw error;
  }

  componentDidCatch(_error, _errorInfo) {
    // Error handled silently - DOM reconciliation error likely caused by browser extension
  }

  componentDidUpdate(_prevProps, prevState) {
    // Auto-recover on next tick after catching error
    if (this.state.hasError && !prevState.hasError) {
      // Small delay to let the DOM settle, then re-render
      requestAnimationFrame(() => {
        this.setState({ hasError: false });
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // Return children anyway - the re-render on next frame will fix the DOM
      return this.props.children;
    }
    return this.props.children;
  }
}

export default DOMErrorBoundary;
